import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    Agree: yup.boolean().required('Требуется согласие'),
});
